import { createI18n } from "vue-i18n";
// import { useI18n } from "vue-i18n";
import * as lodash from "lodash";

// i18nオブジェクト
export const i18n = createI18n({
  // legacy: false,
  locale: "ja",
  messages: {
    ja: require("@/assets/bundle/ja.json"),
    en: require("@/assets/bundle/en.json"),
  },
});
// i18nロケール設定
export const setLocale = (lang: string): void => {
  i18n.global.locale = lang === "ja" ? "ja" : "en";
};
// i18nロケール取得
export const getLocale = (): string => {
  return i18n.global.locale;
};
// i18nメッセージ取得
export const _$t = (key: string, ...args: string[]): string => {
  const messages = i18n.global.getLocaleMessage(i18n.global.locale);
  let message = messages[key];

  for (let i = 0; i < args.length; i++) {
    message = message.replace(`{${i}}`, args[i]);
  }
  return message;
};
// i18n取得
export const getI18n = (): any => {
  return lodash.cloneDeep(i18n);
};
